/* eslint-disable no-unused-vars */
import { DEGREE, STATUS } from "types/common";
import { COURSE_TYPE } from "./course";
import { ICartInput } from "./common";
import { ApiProductThumbnailImages } from "./product-image";
import {
  EXPLORE_SORT,
  EXPLORE_SORT_QUERY,
} from "enums/new-explore/explore-sort";

export enum EXPLORE_QUERY_PARAMS {
  PAGE = "page",
  COUNT = "count",
  ORDERBY = "orderby",
  STATUS = "status",
  IS_FREE = "is_free",
  LIBRARY = "library",
  PRODUCT_IDS = "product_ids",
  IS_FAVORITE = "isFavorite",
  INSTRUCTOR_IDS = "instructor_ids",
  CATEGORY_IDS = "category_ids",
  KEYWORD = "keyword",
  TYPE = "type",
  SKU = "sku",
  WEBINAR = "webinar",
  DISPLAY = "display",
  WATCH_TIME = "watchTime",
  RE_CACHE = "recache",
  LIMIT = "limit",
}

export interface ExploreQueryParamsType {
  [EXPLORE_QUERY_PARAMS.PAGE]: number;
  [EXPLORE_QUERY_PARAMS.COUNT]?: number;
  [EXPLORE_QUERY_PARAMS.LIMIT]?: number;
  [EXPLORE_QUERY_PARAMS.ORDERBY]: EXPLORE_ORDER_BY;
  [EXPLORE_QUERY_PARAMS.STATUS]: EXPLORE_STATUS;
  [EXPLORE_QUERY_PARAMS.IS_FREE]?: string;
  [EXPLORE_QUERY_PARAMS.LIBRARY]?: boolean;
  [EXPLORE_QUERY_PARAMS.PRODUCT_IDS]?: string;
  [EXPLORE_QUERY_PARAMS.IS_FAVORITE]?: boolean;
  [EXPLORE_QUERY_PARAMS.INSTRUCTOR_IDS]?: string;
  [EXPLORE_QUERY_PARAMS.CATEGORY_IDS]?: string;
  [EXPLORE_QUERY_PARAMS.KEYWORD]?: string;
  [EXPLORE_QUERY_PARAMS.TYPE]?: EXPLORE_TYPE;
  [EXPLORE_QUERY_PARAMS.SKU]?: string;
  [EXPLORE_QUERY_PARAMS.WEBINAR]?: WEBINAR_STATUS;
  [EXPLORE_QUERY_PARAMS.DISPLAY]?: CARDS_DISPLAY_MODE;
  [EXPLORE_QUERY_PARAMS.WATCH_TIME]?: boolean;
  [EXPLORE_QUERY_PARAMS.RE_CACHE]?: 1 | 0;
}

export enum EXPLORE_STATUS {
  ALL = "all",
  PUBLISHED = "published",
  UNPUBLISHED = "not_published",
}

export enum EXPLORE_CERTIFICATE {
  ALL = "all",
  WITH = "with",
}

export enum COURSE_STATUS {
  PUBLISHED = "published",
  UNPUBLISHED = "unPublished",
  PUBLISHING = "publishing",
  EDITING = "editing",
  RECORDING = "recording",
  START_RECORDING = "start_recording",
  PLANNING = "planning",
  ALL = "all",
}

export enum WEBINAR_STATUS {
  REGISTRATION = "registration",
  HOLD = "Hold",
  PUBLISHED = "published",
  ALL = "all",
}

export enum COURSE_PRICE {
  FREE = "1",
  NON_FREE = "0",
}

export enum COURSE_LIBRARY {
  HAS_LIBRARY = "1",
  HAS_NOT_LIBRARY = "0",
}

export enum SCREEN_SIZE {
  MOBILE = "mobile",
  DESKTOP = "desktop",
}

export enum CARDS_DISPLAY_MODE {
  LIST_LG = "list-lg",
  GRID = "grid",
}

export enum EXPLORE_TYPE {
  COURSE = "course",
  WEBINAR = "webinar",
  PACKAGE = "package",
  BLIND = "blind",
  PODCAST = "podcast",
  AUDIOBOOK = "audiobook",
  SERVICE = "service",
}

export enum EXPLORE_ORDER_BY {
  RATING = "rating",
  POPULARITY = "popularity",
  VIEWS = "views",
  CREATED_TIME = "created_time",
}

export interface IExploreInstructorInput {
  amount_fixed?: string;
  degree: DEGREE | null;
  last_name: string;
  contract_type_id?: number;
  profile_picture?: string | null;
  biography?: string;
  show_special_description?: number;
  special_description?: null | string;
  special_field?: null | string;
  instructor_caption: string;
  field?: string | null;
  user_id?: number;
  amount_percent?: string;
  biography_excerpt?: string;
  id?: number;
  first_name: string;
  slug?: string;
}
export interface IExploreCartInput
  extends Partial<Pick<ApiProductThumbnailImages, "svg_image" | "webp_image">> {
  id: number;
  title: string;
  sku?: string;
  status: STATUS;
  progress_status?: STATUS;
  price: number;
  duration: number;
  png_image: string;
  product_view: number;
  is_buy: boolean;
  is_favorite: boolean;
  url: string;
  type: COURSE_TYPE;
  instructors?: IExploreInstructorInput[];
  price_display?: string;
}

export interface IExploreFiltersInput {
  categories?: { [key: number]: string };
  instructors?: { [key: number]: string };
}
export interface IExploreMetaInput {
  page: string;
  limit: string;
  total_pages: number;
  total: number;
  load_more: boolean;
}
export interface IExploreSeoInput {
  description: string;
  keywords: string;
  title: string;
  bread_crumb: string;
  secondTitle?: string;
}

export interface IExploreInput {
  status: true;
  data: ICartInput[];
  filters: IExploreFiltersInput;
  pagination: IExploreMetaInput;
  seo: IExploreSeoInput;
}

export interface IExploreCategoryInput extends ApiProductThumbnailImages {
  id: number;
  name: string;
  slug: string;
  description: null | string;
  media: string;
}

export interface IExploreCategoryListInput {
  status: boolean;
  data: IExploreCategoryInput[];
  pagination: {
    page: string;
    limit: string;
    total: number;
    load_more: boolean;
  };
}
export interface IExploreCategorySearch {
  status: boolean;
  data: { id: number; name: string }[];
}
export interface IExploreInstructorSearch {
  status: boolean;
  data: { id: number; name: string }[];
}

export interface IExploreFilterView {
  keyword?: string;
  category?: string[];
  price?: COURSE_PRICE;
  status?: EXPLORE_STATUS;
  type?: EXPLORE_TYPE;
  library?: COURSE_LIBRARY;
  instructor?: string[];
  webinar: WEBINAR_STATUS;
}

export const defaultQueryParams = {
  [EXPLORE_QUERY_PARAMS.PAGE]: 1,
  [EXPLORE_QUERY_PARAMS.COUNT]: 24,
  [EXPLORE_QUERY_PARAMS.ORDERBY]: EXPLORE_ORDER_BY.POPULARITY,
  [EXPLORE_QUERY_PARAMS.STATUS]: EXPLORE_STATUS.PUBLISHED,
};

export const excludeBackendQueryParams = [EXPLORE_QUERY_PARAMS.DISPLAY];

export interface IExploreActions {
  getQueryParam: (
    key: EXPLORE_QUERY_PARAMS
  ) => string | number | boolean | undefined;
  setQueryParam: (
    key: EXPLORE_QUERY_PARAMS,
    value: string | number | string[] | number[]
  ) => void;
  setQueryParams: (
    data: { key: EXPLORE_QUERY_PARAMS; value: string | string[] }[]
  ) => void;
  removeQueryParam: (
    key: EXPLORE_QUERY_PARAMS | EXPLORE_QUERY_PARAMS[]
  ) => void;
}
export interface IExploreActionsProps {
  actions: IExploreActions;
}

export const exploreTypeTitle = {
  [EXPLORE_TYPE.PACKAGE]: "گنجینه",
  [EXPLORE_TYPE.AUDIOBOOK]: "کتاب‌‌صوتی",
  [EXPLORE_TYPE.BLIND]: " نابینایان",
  [EXPLORE_TYPE.PODCAST]: "پادکست",
  [EXPLORE_TYPE.COURSE]: "ویدیویی",
  [EXPLORE_TYPE.WEBINAR]: "وبینار",
  [EXPLORE_TYPE.SERVICE]: "سرویس",
};

export enum EXPLORE_SLUG {
  COURSE = "course",
  LANDING = "landing",
  INSTRUCTOR = "instructor",
}
export const exploreTranslateData = {
  [EXPLORE_SLUG.COURSE]: "products",
  [EXPLORE_SLUG.INSTRUCTOR]: "instructors",
  [EXPLORE_SLUG.LANDING]: "landings",
};

export enum COURSE_COST {
  FREE = "free",
  NOT_FREE = "not_free",
  ALL = "all",
}

export enum EXPLORE_DURATION {
  LESS_THAN_ONE_HOUR = "less_than_one_hour",
  ONE_HOUR_TO_THREE_HOUR = "one_hour_to_three_hours",
  THREE_HOURS_TO_FIVE_HOURS = "three_hours_to_five_hours",
  MORE_THAN_FIVE_HOURS = "more_than_five_hours",
}

export const durationTitle = {
  [EXPLORE_DURATION.LESS_THAN_ONE_HOUR]: "کمتر از  ۱ ساعت",
  [EXPLORE_DURATION.ONE_HOUR_TO_THREE_HOUR]: "۱ تا ۳ ساعت",
  [EXPLORE_DURATION.THREE_HOURS_TO_FIVE_HOURS]: "۳ تا ۵ ساعت",
  [EXPLORE_DURATION.MORE_THAN_FIVE_HOURS]: "بیش از ۵ ساعت",
};

export const exploreSlugTitle = {
  [EXPLORE_SLUG.COURSE]: "آموزش‌ها",
  [EXPLORE_SLUG.INSTRUCTOR]: "پروفایل مدرس",
  [EXPLORE_SLUG.LANDING]: "مجموعه‌های آموزشی",
};

export enum EXPLORE_STATE_MODAL {
  MAIN = "main",
  INSTRUCTOR = "instructor",
  CATEGORY = "category",
}
// Mapping between URL sort query params and backend API sort values.
// Note: 'isCommon: false' items (like RELEVANT) are hidden from the sort bar unless a search term exists.
export const exploreSortItems = [
  {
    name: EXPLORE_SORT.RELEVANCE,
    query: EXPLORE_SORT_QUERY.RELEVANT,
    count: 0,
    selected: false,
    persian_name: "مرتبط‌ترین",
    isCommon: false,
  },
  {
    name: EXPLORE_SORT.MOST_SOLD,
    query: EXPLORE_SORT_QUERY.POPULAR,
    count: 0,
    selected: false,
    persian_name: "محبوب‌ترین",
    isCommon: true,
  },

  {
    name: EXPLORE_SORT.NEWEST,
    query: EXPLORE_SORT_QUERY.NEWEST,
    count: 0,
    selected: false,
    persian_name: "جدیدترین",
    isCommon: true,
  },
];

export interface ExploreProps<T> {
  courseList: T | null;
  query: ExploreQueryParamsType;
  categoryList?: IExploreCategoryListInput | null;
}
